/// <reference lib="WebWorker" />

import { logger } from '@remix-pwa/sw';

declare let self: ServiceWorkerGlobalScope;

// worker variables
let icon = '';

// @ts-expect-error
self.logger = logger;

self.addEventListener('install', (event) => {
  event.waitUntil(self.skipWaiting());
});

self.addEventListener('activate', (event) => {
  event.waitUntil(self.clients.claim());
});

self.addEventListener('message', (event) => {
  const { type, payload } = event.data;
  switch (type) {
    case 'update_icon': {
      icon = payload.icon;
      if (icon?.startsWith('/')) {
        icon = `${location.origin}${icon}`;
      }
      break;
    }
  }
});

// Register event listener for the 'push' event.
self.addEventListener('push', (event) => {
  // Retrieve the textual payload from event.data (a PushMessageData object).
  // Other formats are supported (ArrayBuffer, Blob, JSON), check out the documentation
  // on https://developer.mozilla.org/en-US/docs/Web/API/PushMessageData.
  const payload = event.data?.json();
  // Prefer the icon carried in the push payload; fall back to the icon set via
  // update_icon (only present while a page is alive to post it).
  const notificationIcon = payload.icon || icon;

  event.waitUntil(
    self.registration.showNotification(`${payload.title}`, {
      body: payload.body,
      icon: notificationIcon,
      // @ts-expect-error
      image: notificationIcon,
      badge: notificationIcon,
      data: {
        url: payload.data?.url,
      },
    }),
  );
});

self.addEventListener('notificationclick', (event) => {
  event.notification.close(); // Close the notification

  // Extract the URL from the notification data
  const urlToOpen = new URL(event.notification.data.url, self.location.origin).href;

  event.waitUntil(
    self.clients
      .matchAll({
        type: 'window',
        includeUncontrolled: true,
      })
      .then((windowClients) => {
        // Check if there is already an open window/tab with the PWA
        for (let i = 0; i < windowClients.length; i++) {
          const client = windowClients[i];
          if (client.url.startsWith(self.location.origin) && 'focus' in client) {
            client.postMessage({ type: 'navigate', url: urlToOpen });
            client.navigate(urlToOpen);
            return client.focus();
          }
        }

        // If not, then open a new window/tab with the specified URL
        if (self.clients.openWindow) {
          return self.clients.openWindow(urlToOpen);
        }
      }),
  );
});
